var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide:view"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.66663 21.9997C9.66663 21.9997 14.3325 12.833 22.5 12.833C30.6656 12.833 35.3333 21.9997 35.3333 21.9997C35.3333 21.9997 30.6656 31.1663 22.5 31.1663C14.3325 31.1663 9.66663 21.9997 9.66663 21.9997Z",
    stroke: "#213867",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39 31.1667V34.8333C39 35.8058 38.6137 36.7384 37.9261 37.4261C37.2384 38.1137 36.3058 38.5 35.3333 38.5H9.66667C8.69421 38.5 7.76158 38.1137 7.07394 37.4261C6.38631 36.7384 6 35.8058 6 34.8333V31.1667M39 12.8333V9.16667C39 8.19421 38.6137 7.26158 37.9261 6.57394C37.2384 5.88631 36.3058 5.5 35.3333 5.5H9.66667C8.69421 5.5 7.76158 5.88631 7.07394 6.57394C6.38631 7.26158 6 8.19421 6 9.16667V12.8333M22.5 23.8333C22.9862 23.8333 23.4525 23.6402 23.7964 23.2964C24.1402 22.9525 24.3333 22.4862 24.3333 22C24.3333 21.5138 24.1402 21.0475 23.7964 20.7036C23.4525 20.3598 22.9862 20.1667 22.5 20.1667C22.0138 20.1667 21.5475 20.3598 21.2036 20.7036C20.8598 21.0475 20.6667 21.5138 20.6667 22C20.6667 22.4862 20.8598 22.9525 21.2036 23.2964C21.5475 23.6402 22.0138 23.8333 22.5 23.8333Z",
    stroke: "#213867",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dbc3e419610c53b09be7d8fc699a0acf.svg";
export { ForwardRef as ReactComponent };